export default __webpack_public_path__ + "static/media/m1.45c7035d.jpg";